import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { CustomersMenuLinkItem } from './ui/index.tsx';

export const Customers = (): React.JSX.Element => (
	<UFOSegment name="nav4-sidebar-customers">
		<JSErrorBoundary
			fallback="flag"
			id="assets"
			packageName="jiraNavigationAppsSidebarNav4SidebarsContentCustomers"
			teamName="Boysenberry"
		>
			<CustomersMenuLinkItem />
		</JSErrorBoundary>
	</UFOSegment>
);
